const HelpCenter = () => {
    return (
        <div className="content-width-container">
            <h1>How to Get Started</h1>
            <p style={{
                fontSize: '1.2rem',
                color: '#282828'
            }}>
                Welcome to DimeDock! We're here to help you take control of your finances.
            </p>
        </div>
    )
}

export default HelpCenter;


